import type { ComponentType } from 'react';
import { Chip } from '@mui/material';
import type { SvgIconProps } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

export type StatusVariant = 'custom' | 'imported';

const CONFIG: Record<
  StatusVariant,
  { label: string; color: 'secondary' | 'default'; Icon: ComponentType<SvgIconProps> }
> = {
  custom: { label: 'Custom', color: 'secondary', Icon: EditOutlinedIcon },
  imported: { label: 'Imported', color: 'default', Icon: DownloadOutlinedIcon },
};

/** Small status pill: Custom / Imported. */
export function StatusBadge({ variant }: { variant: StatusVariant }) {
  const { label, color, Icon } = CONFIG[variant];
  return (
    <Chip
      size="small"
      color={color}
      variant={color === 'default' ? 'outlined' : 'filled'}
      icon={<Icon sx={{ fontSize: 14 }} />}
      label={label}
      sx={{ height: 20, '& .MuiChip-label': { px: 0.75, fontSize: 11, fontWeight: 600 } }}
    />
  );
}

export default StatusBadge;
